const DefaultCarriers = [
  { code: 'E5', name: 'AIR ARABIA EGYPT' },
  { code: '3O', name: 'AIR ARABIA MAROC' },
  { code: 'I6', name: 'AIR INDUS (PVT.) LTD.' },
  { code: 'ML', name: 'AIR MEDITERRANEE' },
];

export default DefaultCarriers;
